<template>
	<div>
		<h1 class="mb-5">Event Register</h1>
		<div id="app">
			<div class="calendar-controls">
				<div v-if="message" class="notification is-success">{{ message }}</div>

				<b-form-group
					id="input-group-1"
					label="Holiday Ref."
					label-for="input-1"
				>
					<b-form-input
					id="input-1"
					v-model="newItemTitle"
					type="email"
					required
					placeholder="Enter Holiday here"
					></b-form-input>
				</b-form-group>

				<div class="form-group">
					<label>Holiday Date</label>
					<date-picker input-class="form-control" ref="dob" type="date" v-model="newItemStartDate" value-type="format"></date-picker>
				</div>    
		
				<button type="button" v-on:click="addItem" class="btn btn-md btn-info">Add Item</button> 
				<button type="button" v-on:click="removeItem" v-if="selectedItemId" class="btn btn-md btn-danger">Remove {{newItemTitle}}</button> 
			</div>
			<div class="calendar-parent">
				<calendar-view
					:items="items"
					:show-date="showDate"
					:time-format-options="{ hour: 'numeric', minute: '2-digit' }"
					:enable-drag-drop="true"
					:disable-past="disablePast"
					:disable-future="disableFuture"
					:show-times="showTimes"
					:display-period-uom="displayPeriodUom"
					:display-period-count="displayPeriodCount"
					:starting-day-of-week="startingDayOfWeek"
					:class="themeClasses"
					:period-changed-callback="periodChanged"
					:current-period-label="useTodayIcons ? 'icons' : ''"
					:displayWeekNumbers="displayWeekNumbers"
					:enable-date-selection="true"
					:selection-start="selectionStart"
					:selection-end="selectionEnd"
					@date-selection-start="setSelection"
					@date-selection="setSelection"
					@date-selection-finish="finishSelection"
					@drop-on-date="onDrop"
					@click-date="onClickDay"
					@click-item="onClickItem"
				>
					<calendar-view-header
						slot="header"
						slot-scope="{ headerProps }"
						:header-props="headerProps"
						@input="setShowDate"
					/>
				</calendar-view>
			</div>
		</div>
	</div>
</template>
<script>
require("vue-simple-calendar/static/css/default.css")
import {
	CalendarView,
	CalendarViewHeader,
	CalendarMathMixin,
} from "vue-simple-calendar"
import common from '@/assets/js/common.js';
import DatePicker from 'vue2-datepicker';

export default {
	name: "App",
	components: {
		DatePicker,
		CalendarView,
		CalendarViewHeader,
	},
	mixins: [common, CalendarMathMixin],
	data() {
		return {
			/* Show the current month, and give it some fake items to show */
			showDate: this.thisMonth(1),
			message: "",
			startingDayOfWeek: 0,
			disablePast: false,
			disableFuture: false,
			displayPeriodUom: "month",
			displayPeriodCount: 1,
			displayWeekNumbers: false,
			showTimes: true,
			selectionStart: null,
			selectionEnd: null,
			newItemTitle: "",
			newItemStartDate: "",
			newItemEndDate: "",
			selectedItemId: false,
			useDefaultTheme: true,
			useHolidayTheme: true,
			useTodayIcons: false,
			items: [],
		}
	},
	computed: {
		userLocale() {
			return this.getDefaultBrowserLocale
		},
		dayNames() {
			return this.getFormattedWeekdayNames(this.userLocale, "long", 0)
		},
		themeClasses() {
			return {
				"theme-default": this.useDefaultTheme,
				"holiday-us-traditional": this.useHolidayTheme,
				"holiday-us-official": this.useHolidayTheme,
			}
		},
	},
	mounted() {
		this.newItemStartDate = this.isoYearMonthDay(this.today())
		this.newItemEndDate = this.isoYearMonthDay(this.today())
	},
	methods: {
		periodChanged() {
			// range, eventSource) {
			// Demo does nothing with this information, just including the method to demonstrate how
			// you can listen for changes to the displayed range and react to them (by loading items, etc.)
			//console.log(eventSource)
			//console.log(range)
		},
		thisMonth(d, h, m) {
			const t = new Date()
			return new Date(t.getFullYear(), t.getMonth(), d, h || 0, m || 0)
		},
		onClickDay(d) {
			this.selectionStart = null
			this.selectionEnd = null
			//this.selectedItemId = null
            //this.message = `You clicked: ${d.toLocaleDateString()}`
            this.newItemStartDate = this.isoYearMonthDay(d)
            
		},
		onClickItem(item, e) {
			//this.message = `You clicked: ${e.title}`
			this.newItemStartDate = item.originalItem.startDate
			this.newItemTitle = item.originalItem.title
			this.selectedItemId = item.originalItem.id
		},
		setShowDate(d) {
			//this.message = `Changing calendar view to ${d.toLocaleDateString()}`
			this.showDate = d
		},
		setSelection(dateRange) {
			this.selectionEnd = dateRange[1]
			this.selectionStart = dateRange[0]
		},
		finishSelection(dateRange) {
			this.setSelection(dateRange)
			//this.message = `You selected: ${this.selectionStart.toLocaleDateString()} -${this.selectionEnd.toLocaleDateString()}`
		},
		async onDrop(item, date) {
			//this.message = `You dropped ${item.id} on ${date.toLocaleDateString()}`
			// Determine the delta between the old start date and the date chosen,
			// and apply that delta to both the start and end date to move the item.
			const eLength = this.dayDiff(item.startDate, date)
			item.originalItem.startDate = this.addDays(item.startDate, eLength)
			item.originalItem.endDate = this.addDays(item.endDate, eLength)
			var event = await this.call_axios('set_events', 'post', {event_id: item.originalItem.id, event_date: item.originalItem.startDate, event_title: item.originalItem.title});

			//item.originalItem.endDate = event.response.data.event_id;

		},
		async addItem() {
			if(this.newItemTitle){
				var item = await this.call_axios('set_events', 'post', {event_date: this.newItemStartDate, event_title: this.newItemTitle});
				this.items.push({
					startDate: this.newItemStartDate,
					endDate: this.newItemStartDate,//this.newItemEndDate,
					title: this.newItemTitle,
					id: item.response.data.event_id
				})
				
				this.$toasted.success('New event added successfully.', { duration: 1000 });
			}
        },
        async getEvents(){
            var items = await this.call_axios('get_events'); 

        	items.response.data.map((item, key) => {
                this.items.push({
                    startDate: item.event_date,
                    endDate: item.event_date,
                    title: item.event_title,
                    id: item.event_id,
                })
            });
		},
		removeItem(){
			this.call_axios('delete_events', 'post', {event_id: this.selectedItemId});
			this.items.filter((item, index) => {
				if(item.id == this.selectedItemId){
					this.items.splice(index,1);
					this.selectedItemId = null;
				}
			});
			
			this.$toasted.success('Successfully removed!.', { duration: 1000 });
		}
    },
    created() {
        this.getEvents();
    }
}
</script>

<style>
html,
body {
	height: 100%;
	margin: 0;
	background-color: #f7fcff;
}
#app {
	display: flex;
	flex-direction: row;
	font-family: Calibri, sans-serif;
	width: 95vw;
	min-width: 30rem;
	max-width: 100rem;
	min-height: 40rem;
	margin-left: auto;
	margin-right: auto;
}
.calendar-controls {
	margin-right: 1rem;
	min-width: 14rem;
	max-width: 14rem;
}
.calendar-parent {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	overflow-x: hidden;
	overflow-y: hidden;
	max-height: 80vh;
	background-color: white;
}
/* For long calendars, ensure each week gets sufficient height. The body of the calendar will scroll if needed */
.cv-wrapper.period-month.periodCount-2 .cv-week,
.cv-wrapper.period-month.periodCount-3 .cv-week,
.cv-wrapper.period-year .cv-week {
	min-height: 6rem;
}
/* These styles are optional, to illustrate the flexbility of styling the calendar purely with CSS. */
/* Add some styling for items tagged with the "birthday" class */
.theme-default .cv-item.birthday {
	background-color: #e0f0e0;
	border-color: #d7e7d7;
}
.theme-default .cv-item.birthday::before {
	content: "\1F382"; /* Birthday cake */
	margin-right: 0.5em;
}
</style>